var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"focus_outline-none",attrs:{"id":"main","role":"main","tabindex":"-1"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }